<template>
  <div class="app-container" v-loading="loading">
    <!-- 搜索栏 -->
    <el-form @submit.native.prevent :model="queryParams" :inline="true">
      <el-form-item label="">
        <el-input @keyup.enter="handleQuery" v-model="queryParams.projectNameORApprovalNumber" style="width: 200px" placeholder="项目名称/备案号" clearable />
      </el-form-item>
      <!-- <el-form-item label="">
        <el-select
          v-model="queryParams.generalContractorContact"
          placeholder="全部负责人"
        >
          <el-option label="张三" value="0"></el-option>
          <el-option label="李四" value="1"></el-option>
          <el-option label="王五麻子" value="2"></el-option>
        </el-select>
      </el-form-item> -->
      <el-form-item label="">
        <el-select v-model="queryParams.amountLevel" placeholder="全部金额范围">
          <el-option label="全部" value=""></el-option>
          <el-option label="100w以下" :value="0"></el-option>
          <el-option label="100w以上" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">搜索</el-button>
        <el-button type="info" icon="el-icon-search" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <!-- 操作按钮 -->
    <el-row :gutter="10" class="mb15 operation-buttons">
      <!-- <el-col :span="1.5">
        <el-button>
          <el-icon>
            <Plus></Plus>
          </el-icon>
          导入投诉
        </el-button>
      </el-col> -->
      <el-col :span="1.5">
        <el-button type="primary" @click="toPageAdd" v-hasPerm="'perm:add_project'"> 新增项目</el-button>
      </el-col>
      <el-col :span="1.5">
        <div v-hasPerm="'perm:add_project'" class="batch-insert-wrapper">
          <myBatchInsert type="project" @handleUpdateData="getList"></myBatchInsert>
        </div>
      </el-col>
      <!-- <el-col :span="1.5">
        <el-button type="primary">
          <el-icon><Download></Download></el-icon>批量生成二维码</el-button
        >
      </el-col> -->
    </el-row>
    <!-- 表格展示 -->
    <el-table border :data="onlineList" class="data-table">
      <!-- <el-table-column
        type="selection"
        width="55"
      ></el-table-column> -->
      <el-table-column type="index" label="序号" align="center" width="60"></el-table-column>
      <el-table-column prop="projectName" label="项目名称" min-width="150" show-overflow-tooltip> </el-table-column>
      <!-- 施工许可/备案号 -->
      <el-table-column prop="approvalNumber" label="施工许可/备案号" width="200" show-overflow-tooltip></el-table-column>
      <!-- 总包单位 -->
      <el-table-column prop="generalContractor" label="总包单位" width="150" show-overflow-tooltip></el-table-column>

      <!-- 分包单位 -->
      <el-table-column prop="subcontractors" label="分包单位" width="190" show-overflow-tooltip>
        <template slot-scope="{ row }">
          <span v-if="row.subcontractors && row.subcontractors.length">
            {{ row.subcontractors.map((item) => item.subcontractorsName).join('、') }}
          </span>
          <span v-else>-</span>
        </template>
      </el-table-column>

      <!-- 负责人 -->
      <el-table-column prop="generalContractorContactName" label="负责人" width="100" show-overflow-tooltip></el-table-column>
      <!-- 项目金额(万元) -->
      <el-table-column prop="projectBudget" label="项目金额(万元)" width="150"></el-table-column>
      <!-- 二维码状态二维码状态（0：未生成，1：已生成，2：已张贴） -->
      <el-table-column prop="qrCodeStatus" label="二维码状态" width="200">
        <template slot-scope="scope">
          <div class="create-time">
            <span v-if="scope.row.qrCodeStatus == 0" style="margin-left: 10px">未生成</span>
            <span v-if="scope.row.qrCodeStatus == 1" style="margin-left: 10px">已生成</span>
            <span v-if="scope.row.qrCodeStatus == 2" style="margin-left: 10px">已张贴</span>
          </div>
        </template>
      </el-table-column>
      <!-- 项目状态项目状态（0：在建，1：完工，2：停工） -->
      <!-- <el-table-column prop="loginTime" label="项目状态" min-width="90">
        <template #default="scope">
          <div class="create-time">
            <span v-if="scope.row.qrCodeStatus == 0" style="margin-left: 10px">在建</span>
            <span v-if="scope.row.qrCodeStatus == 1" style="margin-left: 10px">完工</span>
            <span v-if="scope.row.qrCodeStatus == 2" style="margin-left: 10px">停工</span>
          </div>
        </template>
      </el-table-column> -->
      <!-- 操作 -->
      <el-table-column label="操作" fixed="right">
        <template slot-scope="scope">
          <el-button type="text" @click="handleView(scope.row.id)">查看</el-button>
          <el-button type="text" @click="handleEdit(scope.row.id)">编辑</el-button>
          <el-button type="text" style="color: #F56C6C;" @click="handleDelete(scope.row.id)" v-if="0"> 生成二维码 </el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div class="pagination-wrapper">
      <pagination v-if="count > 0" :total="count" :page.sync="queryParams.current" :limit.sync="queryParams.size" @pagination="getList" />
    </div>
    <!-- 操作日志详细
    <el-dialog title="查看详情" v-model="open" width="80%" append-to-body>
      <el-form :model="exceptionLog" label-width="120px">
        <div>
          投诉编号：{{ exceptionLog.module }}
        </div>
        <div>
          项目名称：{{ exceptionLog.module }}
        </div>
        <div>
         投诉人姓名： {{ exceptionLog.module }}
        </div>
        <div>
         岗位： {{ exceptionLog.module }}
        </div>
        <el-form-item label="欠薪金额(元)：">
          欠薪金额(元)：{{ exceptionLog.module }}
        </el-form-item>
        <div>
         投诉来源： {{ exceptionLog.module }}
        </div>
        <div>
         分派状态： {{ exceptionLog.module }}
        </div>
        <div>
          处理状态：{{ exceptionLog.module }}
        </div>
        <div>
         结案状态： {{ exceptionLog.module }}
        </div>
        <div>
         提交时间： {{ exceptionLog.module }}
        </div>
        <div>
          是否上传附件：{{ exceptionLog.module }}
        </div>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="open = false">关 闭</el-button>
        </div>
      </template>
    </el-dialog> -->
  </div>
</template>

<script>
import router from '@/router'
// import { getOnlineList, kickOutUser } from "@/api/user";
import { getProjectInfoPage,getQRCode } from '@/api/unpaidWages/monitor'
// import { formatDateTime } from "@/utils/date";
import { messageConfirm, notifySuccess } from '@/utils/modal'

import myBatchInsert from "@/components/myComponents/MyBatchInsert/index.vue";

export default {
  name: 'OnlineMonitor',
  components: {
    myBatchInsert
  },
  data() {
    return {
      count: 0,
      open: false,
      loading: false,
      queryParams: {
        generalContractorContact: '',
        projectNameORApprovalNumber: '',
        amountLevel: 0,
        current: 1,
        size: 10,
      },
      onlineList: [],
      logIdList: [],
      exceptionLog: {},
    }
  },
  mounted() {
    this.getList()
  },
  methods: {
    kick() {
      // messageConfirm("确定要下线该用户吗?").then(() => {
      //     kickOutUser(token).then(({ data }) => {
      //         if (data.flag) {
      //             notifySuccess(data.msg);
      //             this.getList();
      //         }
      //     })
      // }).catch(() => { });
    },
    reset() {
      this.queryParams.current = 1
      this.queryParams.generalContractorContact = ''
      this.queryParams.projectNameORApprovalNumber = ''
      this.queryParams.amountLevel = ''
      this.handleQuery()
    },
    handleView(id) {
      console.log(id)
      this.open = true
      router.push({
        path: `/laborRelations/unpaidWages/monitor/task`,
        query: {
          id: id,
          type: 'info',
        },
      })
    },
    handleEdit(id) {
      console.log(id)
      this.open = true
      router.push({
        path: `/laborRelations/unpaidWages/monitor/task`,
        query: {
          id: id,
          type: 'eidt',
        },
      })
    },
    toPageAdd() {
      console.log('123')
      router.push({ path: `/laborRelations/unpaidWages/monitor/task` })
    },
    // 导入
    importList() {
      console.log("导入");
    },
    // 导出
    exportList() {
      console.log("导出");
    },
    assign() {
      // let ids = []
      // if (id == undefined) {
      //   ids = this.logIdList
      // } else {
      //   ids = [id]
      // }
      // messageConfirm('分派成功?')
      //   .then(() => {
      //     deleteException(ids).then(({ data }) => {
      //       if (data.flag) {
      //         notifySuccess(data.msg)
      //         // this.getList();
      //       }
      //     })
      //   })
      //   .catch(() => {})
    },
    getList() {
      this.loading = true
      /**重新定义请求格式参数 */
      const queryParams = {
        query: {
          generalContractorContact: this.queryParams.generalContractorContact,
          projectNameORApprovalNumber: this.queryParams.projectNameORApprovalNumber,
          amountLevel: this.queryParams.amountLevel,
        },
        pageNum: this.queryParams.current,
        pageSize: this.queryParams.size,
      }
      getProjectInfoPage(queryParams).then((res) => {
        // 接口返回 { code, msg, data }，分页数据在 data 里：rows、total、pageNum、pageSize
        const body = res.data != null ? res.data : res
        const data = body.data != null ? body.data : body
        const rows = (data.rows || []).map((row) => {
          const item = { ...row }
          if (item.subcontractorsStr) {
            try {
              item.subcontractors = typeof item.subcontractorsStr === 'string' ? JSON.parse(item.subcontractorsStr) : item.subcontractorsStr
            } catch (e) {
              item.subcontractors = []
            }
          }
          return item
        })
        this.onlineList = rows
        this.count = data.total ?? 0
        this.loading = false
      }).catch(() => {
        this.loading = false
      })
    },
    handleQuery() {
      this.queryParams.current = 1
      this.getList()
    },
    handleDelete(id) {
      messageConfirm('确认生成二维码?')
        .then(() => {
          getQRCode(id).then(({ data }) => {
            if (data.flag) {
              notifySuccess(data.msg)
              // this.getList();
            }
          })
        })
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
/* 操作按钮区域样式 */
.operation-buttons {
  margin-bottom: 20px;
}

/* 批量导入组件包装器，添加间距 */
.batch-insert-wrapper {
  display: inline-block;
}

.batch-insert-wrapper ::v-deep .el-dropdown {
  margin-right: 10px;
}

.batch-insert-wrapper ::v-deep .el-dropdown-menu .el-dropdown-item {
  padding: 8px 0;
}

.batch-insert-wrapper ::v-deep .el-dropdown-menu .el-dropdown-item:not(:last-child) {
  margin-bottom: 8px;
}

.batch-insert-wrapper ::v-deep .el-dropdown-menu .el-dropdown-item .el-button {
  width: 100%;
  margin: 0;
}

/* 表格样式 - 设置最小高度和间距 */
.data-table {
  min-height: 400px;
  margin-top: 0;
  overflow-y: auto;
}

/* 确保表格容器有足够的高度 */
.app-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

/* 搜索栏样式 */
.el-form {
  margin-bottom: 20px;
}

/* 分页样式 */
.pagination-wrapper {
  margin-top: 20px;
}
</style>
